"use client"

import { cn } from "@/lib/cn"
import * as LabelPrimitive from "@radix-ui/react-label"
import { ComponentPropsWithRef } from "react"

export function Label({
  className,
  ref,
  ...props
}: ComponentPropsWithRef<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      ref={ref}
      className={cn(
        "text-paragraph-l font-normal peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
        className,
      )}
      {...props}
    />
  )
}
